import React from "react";
import { useNavigate } from "react-router-dom";
import { StatusBar } from "../components/Shell";
import Ico from "../components/Ico";
import { notifications } from "../mock";
import { ChevronLeft } from "lucide-react";

export default function Notifications() {
  const navigate = useNavigate();
  return (
    <div className="gd-screen bg-[#eef1fb]">
      <div className="flex-shrink-0 px-5 pb-5" style={{ background: "linear-gradient(160deg,#3b57c9,#2b3f96)", borderBottomLeftRadius: 28, borderBottomRightRadius: 28 }}>
        <StatusBar dark={false} />
        <div className="mt-1 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button onClick={() => navigate(-1)} className="gd-tap grid h-10 w-10 place-items-center rounded-full bg-white/15"><ChevronLeft size={20} color="#fff" /></button>
            <div><h1 className="text-2xl font-extrabold text-white">Notifications</h1><p className="text-sm text-white/70">3 new updates</p></div>
          </div>
          <button className="gd-tap rounded-full bg-white/15 px-3 py-1.5 text-xs font-bold text-white">Mark All Read</button>
        </div>
      </div>

      <div className="gd-scroll px-4 py-4 gd-stagger">
        <div className="space-y-3">
          {notifications.map((n) => (
            <div key={n.id} className="gd-card flex items-start gap-3 p-4">
              <div className="grid h-11 w-11 flex-shrink-0 place-items-center rounded-2xl" style={{ background: `${n.tint}18` }}>
                <Ico name={n.icon} size={20} color={n.tint} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <p className="truncate text-sm font-extrabold text-[#1f2a52]">{n.title}</p>
                  {n.dot && <span className="h-2 w-2 flex-shrink-0 rounded-full" style={{ background: n.dot }} />}
                </div>
                <p className="mt-0.5 text-[12px] leading-snug text-[#5b648a]">{n.body}</p>
                <p className="mt-1 text-[10px] font-semibold text-[#a3abc9]">{n.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
